import { render, staticRenderFns } from "./_DoRegNumber.vue?vue&type=template&id=e5baf800"
import script from "./_DoRegNumber.vue?vue&type=script&lang=js"
export * from "./_DoRegNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports